/**
 * Created by Mark on 28/07/17.
 */




export default class Product {

    constructor(uid , name , students){

    }

    isHuber(){
        return sessionStorage.getItem("product") == "huber"
    }

    isContentOverviewAvaliable(){
        return sessionStorage.getItem("product") != "pratstart"
    }
}


// WEBPACK FOOTER //
// ./src/classes/product.js